// Types
import { blue, grey } from '../../../common/styles/colours';
/**
 * @deprecated Please use the `contentColor` prop instead
 */
export var PrefixLabelStylePropertiesByVariant = {
    grey: function (theme) {
        var _a;
        return ({
            color: (_a = theme.contentTertiary) !== null && _a !== void 0 ? _a : grey[600],
        });
    },
    blue: function (theme) {
        var _a;
        return ({
            color: (_a = theme.contentAccent) !== null && _a !== void 0 ? _a : blue[900],
        });
    },
};
//# sourceMappingURL=PrefixLabelStylePropertiesByVariant.js.map